import '../../../mode-components';

import * as angular from 'angular';

class DesignerEmptyTableController {
  constructor() {}

  isRadialChart(chartType) {
    return chartType === 'pie' || chartType === 'donut';
  }

  isLinePlusBarChart(chartType) {
    return chartType === 'linePlusBar';
  }
}

export const DesignerEmptyTableComponent: angular.IComponentOptions = {
  bindings: {
    paneView: '<',
    chartType: '<',
  },
  template: `
    <div ng-if="ctrl.paneView === 'MAXIMIZED'" class="empty-table-maximized">
      <p>Create a chart to see its table results:</p>
      <ul ng-show="!ctrl.isRadialChart(ctrl.chartType) && !ctrl.isLinePlusBarChart(ctrl.chartType)">
        <li>&#8226; 1 field in the x-axis</li>
        <li>&#8226; 1 or more fields in the y-axis</li>
      </ul>
      <ul ng-show="ctrl.isRadialChart(ctrl.chartType)">
        <li>&#8226; 1 field in color</li>
        <li>&#8226; 1 field in angle</li>
      </ul>
      <ul ng-show="ctrl.isLinePlusBarChart(ctrl.chartType)">
        <li>&#8226; 1 field in the x-axis</li>
        <li>&#8226; 2 fields in the y-axes</li>
      </ul>
      <i class="icon-empty-table-mini empty-table"></i>
    </div>
    <div ng-if="ctrl.paneView === 'REGULAR'" class="empty-table-split">
      <mode-table-loading [with-animation]="false"></mode-table-loading>
    </div>
  `,
  controller: DesignerEmptyTableController,
  controllerAs: 'ctrl',
};
